import * as React from "react"
import env from "../../../../../env"
import { Labels } from "../../../../../util/Translations"
import { IBreadcrumb } from "../index"

interface Props {
    breadcrumb: IBreadcrumb
}

export const Breadcrumb = ({
    breadcrumb: { name, location },
    ...attrs
}: Props): JSX.Element => {
    const { WelcomePage, WelcomePageLogo } = Labels

    const title = name === WelcomePageLogo ? WelcomePage : name

    return (
        <>
            {!!location ? (
                <>
                    <a
                        href={env.applicationPath + location}
                        className="label default is-inverted no-underline is-ellipsed"
                        data-ft-breadcrumb-type="relative"
                        title={title}
                        data-ft-name={name}
                        {...attrs}
                    >
                        {name}
                    </a>
                    <div className="separator is-inverted label">/</div>
                </>
            ) : (
                <>
                    <div
                        className="label default is-inverted no-underline is-ellipsed is-dimmed"
                        data-ft-breadcrumb-type="relative"
                        title={title}
                        data-ft-name={name}
                        {...attrs}
                    >
                        {name}
                    </div>
                    <div className="separator is-inverted label is-dimmed">
                        /
                    </div>
                </>
            )}
        </>
    )
}

export default Breadcrumb
